import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { AppDispatch } from 'src/actions/app-state/app-state'
import { callToAction, callToActionWithFlag } from 'src/actions/onboarding_cta/onboarding_cta'

// This hook is used for CTAs which should only occur once in 12 hours.
export const useCallToActionWithFlag = (): void => {
  const dispatch = useDispatch<AppDispatch>()

  // TODO: reimplement after gql migration; we need to pass in the pagination info from the feed requests
  dispatch(callToActionWithFlag(0))
}

export const useCallToAction = () => {
  const dispatch = useDispatch<AppDispatch>()
  return useCallback(() => {
    dispatch(callToAction())
  }, [dispatch])
}
